import { Box, Link, Typography } from "@mui/material";

import androidImage from "../assets/dl-android.png";

const Footer = () => {
  return (
    <Box sx={{ m: 3 }} textAlign="center">
      <Typography variant="body1" component="div" sx={{ mb: 2 }}>
        Un outil de{" "}
        <Link
          fontWeight="bold"
          color="primary"
          target="_blank"
          rel="noreferrer"
          href="https://lapil.ch"
        >
          L'APIL
        </Link>
      </Typography>
      <Box
        sx={{
          mt: 2,
          display: "flex",
          justifyContent: "center",
          alignItems: "flex-start",
          gap: 4,
          flexWrap: "wrap",
        }}
      >
        <Box sx={{ minWidth: 150 }}>
          <Typography variant="body2" sx={{ mb: 1 }}>
            Téléchargez l'application iOS:
          </Typography>
          <Link
            href="https://apps.apple.com/app/apple-store/id6759932379?pt=127913953&ct=Webapp%20Footer&mt=8"
            target="_blank"
            rel="noreferrer"
          >
            <Box
              component="img"
              src="https://tools.applemediaservices.com/api/badges/download-on-the-app-store/black/fr-fr?size=250x83"
              height={50}
              alt="Télécharger dans l'App Store"
            />
          </Link>
        </Box>
        <Box sx={{ minWidth: 150 }}>
          <Typography variant="body2" sx={{ mb: 1 }}>
            Téléchargez l'application android:
          </Typography>
          <Link
            href="https://apiceras.ch/dico/"
            target="_blank"
            rel="noreferrer"
          >
            <Box
              component="img"
              src={androidImage}
              height={50}
              alt="Télécharger l'application android"
            />
          </Link>
        </Box>
      </Box>
    </Box>
  );
};

export default Footer;
